import { Box, Theme, styled } from '@mui/material';
import { MaterialDesignContent } from 'notistack';
import { forwardRef } from 'react';
import type { StyledSnackbarContentProps } from './types';

const commonStyles = (theme: Theme) => ({
  position: 'relative',
  backgroundColor: theme.palette.neutral[800],
  width: '100%',
  borderRadius: 4,
  padding: '32px 24px',
  boxShadow: 'none',
  textAlign: 'center',
  '& > *': {
    margin: 'auto',
  },

  [theme.breakpoints.down('sm')]: {
    padding: '16px 12px',
  },
});

const StyledContent = styled(MaterialDesignContent)(({ theme }) => ({
  '&.notistack-MuiContent-success': {
    ...commonStyles(theme),
    color: theme.palette.success.light,
    border: `1px solid ${theme.palette.success.light}`,
  },
  '&.notistack-MuiContent-info': {
    ...commonStyles(theme),
    border: `1px solid ${theme.palette.neutral[100]}`,
  },
  '&.notistack-MuiContent-warning': {
    ...commonStyles(theme),
    color: theme.palette.error.main,
    border: `1px solid ${theme.palette.error.main}`,
  },
  '&.notistack-MuiContent-error': {
    ...commonStyles(theme),
    color: theme.palette.error.main,
    border: `1px solid ${theme.palette.error.main}`,
  },
}));

const LegacySnackbarContent = forwardRef<HTMLDivElement, StyledSnackbarContentProps>(
  ({ id, message, variant, action, onClose, closeLabel: _closeLabel, ...rest }, ref) => (
    <Box ref={ref} onClick={onClose} sx={{ cursor: 'pointer' }}>
      <StyledContent {...rest} id={id} message={message} variant={variant} action={action} hideIconVariant />
    </Box>
  )
);

export default LegacySnackbarContent;
